/**
 * SYNC: copied verbatim from theplaidoyer-frontend/src/lib/bidi.ts
 *       @ FE SHA 65f3ebfd62430a199b586e5304c01810563514fd (2026-05-29).
 */
const RTL_RANGE =
  /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g

// Threshold validated on 59 real Arabic fragments from Neon DB (A0.2).
// All fragments scored 1.0 (pure Arabic, no Latin inline).
// 0.3 chosen as safe default with margin for future mixed content.
const RTL_THRESHOLD = 0.3

/** Detect the dominant direction of a text string.
 * Strips digits, spaces, punctuation — counts only alphabetic characters.
 * Returns 'rtl' if >30% of alpha chars are Arabic script. */
export function getTextDirection(text: string): 'rtl' | 'ltr' {
  const stripped = text.replace(/[\s\d\p{P}\p{S}]/gu, '')
  if (stripped.length === 0) return 'ltr'
  const rtlChars = stripped.match(RTL_RANGE)
  return rtlChars && rtlChars.length / stripped.length > RTL_THRESHOLD
    ? 'rtl'
    : 'ltr'
}

/** Detect language from text direction. */
export function getTextLang(text: string): 'ar' | 'fr' {
  return getTextDirection(text) === 'rtl' ? 'ar' : 'fr'
}

/** Props to spread on an element displaying legal content.
 * Returns { dir, lang } based on text direction analysis. */
export function bidiProps(text: string): {
  dir: 'rtl' | 'ltr'
  lang: 'ar' | 'fr'
} {
  const dir = getTextDirection(text)
  return { dir, lang: dir === 'rtl' ? 'ar' : 'fr' }
}

/** Strip Unicode BiDi control characters to prevent spoofing.
 * Removes LRE/RLE/PDF/LRO/RLO/LRI/RLI/FSI/PDI and LRM/RLM marks. */
export function sanitizeBidi(text: string): string {
  return text.replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '')
}
